// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__1IxrI","NavbarContent":"Navbar_NavbarContent__3n1PY","logo":"Navbar_logo__1H3m4","redditLogo":"Navbar_redditLogo__2Tzny"};